const faqs = [
  {
    question: "Does Texas have its own regional passport agency?",
    answer:
      "Yes — Texas is served by three regional passport agencies. The Houston Passport Agency (1919 Smith St, Suite 1400, Houston, TX 77002) serves southern and central Texas. The Dallas Passport Agency (300 Commerce St, Suite 100, Dallas, TX 75242) serves the DFW metroplex and northern Texas. The El Paso Passport Agency (303 N Oregon St, Suite 200, El Paso, TX 79901) serves El Paso and far west Texas. All three handle life-or-death emergencies and travel within 14 days by appointment only. Most Texas travelers find that using an approved courier like Fast Passport Center is faster and more convenient than scheduling an appointment at a regional agency.",
  },
  {
    question: "How fast can I get a passport in Texas?",
    answer:
      "With Fast Passport Center's courier service, Texas travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Texas?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or public library). Renewals for adults can usually be done by mail without an in-person visit. Texas has hundreds of acceptance facilities across all major metro areas.",
  },
  {
    question: "Which Texas airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Texas international airports include Houston Bush Intercontinental (IAH), Dallas/Fort Worth (DFW), Austin-Bergstrom (AUS), San Antonio (SAT), and El Paso (ELP).",
  },
  {
    question: "Can I renew by mail from Texas?",
    answer:
      "Yes. If your most recent passport was issued within the last 15 years, when you were age 16 or older, and it is undamaged, you can renew by mail from Texas. However, routine mail-in renewal takes 6–13 weeks. For faster turnaround, our courier service can process your renewal in as little as 24 hours.",
  },
  {
    question: "Where is the best place to get a passport photo in Texas?",
    answer:
      "CVS, Walgreens, Walmart, and UPS Stores all offer passport photo services at most Texas locations. Prices typically range from $14–$18 for two photos. Make sure the location understands State Department requirements: 2×2 inches, white or off-white background, taken within the last 6 months, and no glasses.",
  },
];

export { faqs };

export default function TexasFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Texas Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Texas.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}